import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numberVn' })
export class NumberVNPipe implements PipeTransform {
  transform(value: any): string {
    if (value !== null && value !== undefined && !isNaN(value)) {
      value = +value;
      if (value !== Math.floor(value)) {
        return value.toLocaleString('vi-VN', { minimumFractionDigits: 2 });
      }
      return value.toLocaleString('vi-VN');
    }
    return '';
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/pipe/number-vn.pipe.ts